import { Box, List, ListItem, ListItemIcon, ListItemText, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

// Displays the result of the server-side link check: a green check when
// everything is fine, otherwise the list of German issue messages.
const LinkCheckStatus = ({ linkCheck, okLabel = 'Alles in Ordnung' }) => {
  if (!linkCheck) {
    return (
      <Typography variant='body2' color='text.secondary'>
        Link-Prüfung nicht verfügbar.
      </Typography>
    );
  }

  if (linkCheck.ok) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <CheckCircleIcon color='success' fontSize='small' />
        <Typography variant='body2'>{okLabel}</Typography>
      </Box>
    );
  }

  const issues = Array.isArray(linkCheck.issues) ? linkCheck.issues : [];

  return (
    <List dense disablePadding>
      {issues.map((issue, index) => (
        <ListItem key={`${issue.code || 'issue'}-${issue.elementId || index}`} disableGutters sx={{ py: 0.25 }}>
          <ListItemIcon sx={{ minWidth: 30 }}>
            <WarningAmberIcon color='warning' fontSize='small' />
          </ListItemIcon>
          <ListItemText primary={issue.message} primaryTypographyProps={{ variant: 'body2' }} />
        </ListItem>
      ))}
    </List>
  );
};

export default LinkCheckStatus;
